import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TourService {

  // private formData: any = null;
  private formDataSubject = new BehaviorSubject<any>(null); // Holds the latest form data

  setFormData(data: any) {
    this.formDataSubject.next(data); // Update the stored value
  }

  getFormData() {
    return this.formDataSubject.asObservable(); // Return as an observable
  }
}
